import { JsonObject, JsonProperty, JsonDelayedProperty, AbstractModel } from 'projects/core/src/public-api';
import { TrelloObject } from './trello-object';
import { TrelloList } from './trello-list';
import { TrelloChecklist } from './trello-checklist';

@JsonObject('model.CheckItemTask')
export class CheckItemTask extends AbstractModel {
    @JsonProperty(Number, 'id')
    id?: number;

    @JsonProperty(String, 'text')
    text?: string;
}